// Pinia UI store: глобальний лоадер + утиліти
import { defineStore } from "pinia";
import { ref, computed } from "vue";

/**
 * Ключ лоадера. Усі наявні виклики передають рядок ("route",
 * "profile-load", ...); Symbol лишається дефолтом `start()` для
 * анонімних лоадерів, які нікому не треба зупиняти ззовні.
 */
export type LoaderKey = string | symbol;

export const useUiStore = defineStore("ui", () => {
  // активні "ключі" лоадерів; масив — щоб реактивно оновлювалась довжина
  // Параметр типу обов'язковий: ref([]) вивелось би як Ref<never[]>.
  const active = ref<LoaderKey[]>([]);

  const isGlobalLoading = computed(() => active.value.length > 0);

  function start(key: LoaderKey = Symbol("loader")): () => void {
    active.value.push(key);
    // повертаємо зручний "stop"
    return () => stop(key);
  }
  function stop(key: LoaderKey): void {
    const i = active.value.indexOf(key);
    if (i !== -1) active.value.splice(i, 1);
  }
  async function wrap<T>(
    promiseOrFn: Promise<T> | (() => Promise<T> | T),
    key?: LoaderKey,
  ): Promise<T> {
    const stopFn = start(key);
    try {
      const p = typeof promiseOrFn === "function" ? promiseOrFn() : promiseOrFn;
      return await p;
    } finally {
      stopFn();
    }
  }

  return { isGlobalLoading, start, stop, wrap };
});
